export default __webpack_public_path__ + "static/media/cymsa3_g.cc2e09f8.jpg";